export const SliceAccount = (acc: string, start = 5, end = 5) => {
  const accountEllipsis = acc ? `${acc.substring(0, start)}...${acc.substring(acc.length - end)}` : null
  return accountEllipsis
}
